import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';

// icons
import open from '../../assets/svg/open.svg';
import close from '../../assets/svg/close.svg';

// styles
import './style.scss';

class Accordion extends Component {
	state = {
		opened: false,
	};

	toggleAccordion = () => {
		this.setState({
			opened: !this.state.opened,
		});
	};

	render() {
		const { opened } = this.state,
			{ title = 'Open', children, index } = this.props;
		return (
			<Fade bottom>
				<article
					className="accordion"
					role="button"
					tabIndex="0"
					aria-label="Open, This is the title"
					aria-controls={`accordion_${index}`}
					onClick={this.toggleAccordion}
					onKeyDown={(e) => (e.keyCode === 13 ? this.toggleAccordion() : null)}
				>
					<div className={`accordion__title ${opened && 'expanded'}`}>
						<p>{title}</p>
					</div>
					<div
						id={`accordion_${index}`}
						className={`accordion__content ${opened && 'expanded'}`}
						aria-expanded={opened}
						aria-hidden={!opened}
					>
						<div className="accordion__content--wrapper">
							<Fade bottom when={opened}>
								{children}
							</Fade>
						</div>
					</div>
					<div className="accordion__icon">
						{opened && (
							<figure>
								<img src={close} alt="plus icon" />
							</figure>
						)}
						{!opened && (
							<figure>
								<img src={open} alt="plus icon" />
							</figure>
						)}
					</div>
				</article>
			</Fade>
		);
	}
}

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/accordion/index.js